// extracted by mini-css-extract-plugin
export var absolute = "menuCard-module--absolute--3a7e0";
export var image = "menuCard-module--image--f981f";
export var shadow = "menuCard-module--shadow--bc2f7";
export var wrapper = "menuCard-module--wrapper--93fda";